<template>
  <div class="py-1" v-if="actions.length">
    <template v-for="(action, actionIdx) in actions">
      <OrderListItemCreateSoftOneDocumentAction
        :key="actionIdx"
        :order="order"
        :third-party-service-id="action.thirdPartyServiceId"
        :service-name="action.thirdPartyServiceName"
      />
    </template>
  </div>
  <div class="py-1" v-else>
    <div
      class="group px-4 py-2 focus:outline-none w-full text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
    >
      No action
    </div>
  </div>
</template>

<script>
import OrderListItemCreateSoftOneDocumentAction from './order-list-item-create-softone-document-action.vue';

const getDocumentSeriesByStatus = (seriesByStatus, status) => {
  const { series = null } = seriesByStatus.find((item) => item.status === status) || {};

  return series;
};

const getDocumentSpecBySeries = (documentTypes, series) => {
  const {
    documentType = null,
    name: documentName = '',
    follows: expectsDocumentSeries = null,
  } = documentTypes.find((item) => item.number === series) || {};

  return { documentType, documentName, expectsDocumentSeries };
};

const withDocumentSeries = (action) => action.documentSeries !== null;

const notIssuedYet = (existingDocuments) => (action) =>
  !existingDocuments.some(
    (document) =>
      document.thirdPartyServiceId === action.thirdPartyServiceId &&
      document.documentSeries === action.documentSeries
  );

const havingExpectedDocumentSeries = (existingDocuments) => (action) => {
  if (action.expectsDocumentSeries === null) {
    return true;
  }

  return existingDocuments.some(
    (document) =>
      document.thirdPartyServiceId === action.thirdPartyServiceId &&
      document.documentSeries === action.expectsDocumentSeries
  );
};

export default {
  components: {
    OrderListItemCreateSoftOneDocumentAction,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    softoneApiServices: {
      type: Array,
      default: () => [],
    },
    thirdPartyServiceDocuments: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    actions() {
      return this.softoneApiServices
        .map((softOneApiService) => {
          const documentSeries = getDocumentSeriesByStatus(
            softOneApiService?.config?.accOrderStatusToDocumentSeries || [],
            this.order.status
          );

          const { documentName, expectsDocumentSeries } = getDocumentSpecBySeries(
            softOneApiService?.config?.documentTypes || [],
            documentSeries
          );

          return {
            documentSeries,
            expectsDocumentSeries,
            documentName,
            thirdPartyServiceId: softOneApiService.id,
            thirdPartyServiceName: softOneApiService?.config?.name || 'SoftOne',
          };
        })
        .filter(withDocumentSeries)
        .filter(notIssuedYet(this.thirdPartyServiceDocuments))
        .filter(havingExpectedDocumentSeries(this.thirdPartyServiceDocuments))
        .filter(Boolean);
    },
  },
};
</script>
